import Contaier from "../../components/layout/Container/Container";
import CompleteImg from "../../assets/eservice-img-suss.png";
import Header from "../../components/molecules/Header/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const SingleRegComplete = () => {
  const location = useLocation();
  const bannersType = location.state;
  let RegistrationType = "Birds";
  let RegType = "Birds";
  let sourceofFish = "";
  let referenceNumber = "";
  const [isFromRegistrationLink, setIsFromRegistrationLink] = useState(false);
  if (bannersType.RegistrationType !== undefined)
    RegType = bannersType.RegistrationType.RegistrationType;
  if (bannersType.sSourceofFish != undefined)
    sourceofFish = bannersType.sSourceofFish;
  if (bannersType.referenceNumber != undefined)
    referenceNumber = bannersType.referenceNumber;

  let bannerName;
  if (
    bannersType.RegistrationType === "DragonFish" ||
    bannersType.registrationType === "DragonFish" ||
    bannersType === "DragonFish" ||
    RegType === "DragonFish"
  ) {
    RegistrationType = "DragonFish";
    bannerName =
      " Application for Captive-Bred Dragon Fish for Tag List for Export/Re-export ";
  } else if (
    bannersType.RegistrationType === "Crocodile" ||
    bannersType.registrationType === "Crocodile" ||
    bannersType === "Crocodile" ||
    RegType === "Crocodile"
  ) {
    RegistrationType = "Crocodile";
    bannerName =
      "Application for Crocodile skin for Tag List for Export/Re-export";
  } else {
    RegistrationType = "Birds";
    bannerName =
      "Application for Captive-Bred Birds for Tag List for Export/Re-export";
  }

  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/application-registration`;
    navigate(path, { state: { RegistrationType } });
  };

  const routedChange = () => {
    let path = `/harvest-microchipregistration`;
    navigate(path, { state: { RegistrationType } });
  };
  const handleNavigation = () => {
    if (isFromRegistrationLink) {
      routedChange();
    } else {
      routeChange();
    }
  };
  useEffect(() => {
    if (location.state?.from === "/application-registration") {
      setIsFromRegistrationLink(true);
    }
  }, [location.state]);
  return (
    <>
      <Header />
      <Contaier>
        <div className="inner-content pt-5 pb-5">
          <div className="container">
            <div className="landing-page tag-list mt-5 mb-5">
              <figure>
                <img src={CompleteImg} alt="" className="img-fluid" />
              </figure>
              <p>
                Your submission has been successful.
                <br />
                {RegistrationType === "Birds" && (
                  <p>
                    The Leg Rings you have registered are now in NParks'
                    Registry.
                  </p>
                )}
                {RegistrationType === "Crocodile" && (
                  <p>
                    The Tags you have registered are now in NParks' Registry.
                  </p>
                )}
                {RegistrationType === "DragonFish" &&
                  sourceofFish === "1" &&
                  referenceNumber !== "" &&
                  referenceNumber !== undefined && (
                    <p>
                      Thank you for registering your Arowana fishes. This is
                      your reference number #{referenceNumber}. If you're not a
                      GIRO customer, or you wish to make payment online, please
                      use this reference to complete your payment under the
                      "Make Online Payment" section.
                    </p>
                  )}
                {RegistrationType === "DragonFish" &&
                  sourceofFish === "1" &&
                  (referenceNumber === "" || referenceNumber === undefined) && (
                    <p>
                      Thank you for registering your Arowana fishes. Please
                      refer to dashboard for upload status and refrerence
                      number.
                    </p>
                  )}
                {RegistrationType === "DragonFish" && sourceofFish !== "1" && (
                  <p>
                    The Microchips you have registered are now in NParks'
                    Registry.
                  </p>
                )}
              </p>
              <div className="landing-list">
                <p>{bannerName}</p>
              </div>

              <button
                type="button"
                className="btn btn-success mt-4"
                onClick={handleNavigation}
              >
                Back to Registration
              </button>
            </div>
          </div>
        </div>
      </Contaier>
    </>
  );
};

export default SingleRegComplete;
